<script lang="ts" setup>
import { useRoute } from "vue-router";

const route = useRoute();
const page: any = await usePage(route.path.toString());

useSeoData(page?.seo || {});

</script>
<template>
    <HeaderCover type="page" :page="page"/>
    <PageRenderer :page="page"/>    
</template>